import { render, staticRenderFns } from "./BasicOnetoOneReg.vue?vue&type=template&id=03797ecf&scoped=true"
import script from "./BasicOnetoOneReg.vue?vue&type=script&lang=js"
export * from "./BasicOnetoOneReg.vue?vue&type=script&lang=js"
import style0 from "./BasicOnetoOneReg.vue?vue&type=style&index=0&id=03797ecf&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03797ecf",
  null
  
)

export default component.exports